import { TournamentsApi, useApiQuery, type APIQueryOptions } from "@xs2event/js-lib/api";

const tournamentsApi = new TournamentsApi();

/**
 * Every upcoming tournament (date_stop >= today), filtered to the calling distributor's sports.
 * Takes no filters and no pagination — the portal filters client side.
 */
export const usePortalTournamentsCache = (options?: APIQueryOptions) =>
  useApiQuery(tournamentsApi, "tournamentsportalcacheGet", undefined, { debounce: false, ...options });
